import useSWR, { preload } from 'swr';
import { getUserOrganizationsApiv2 } from 'src/api/organization';
import type { Org } from '@equaliq/api-model-v2';

const fetcher = async () => {
  const response = await getUserOrganizationsApiv2({});
  return Object.values(response.organizations ?? {}) as Org[];
};

export const preloadOrganizations = () => preload(['orgs'], fetcher);

export const useOrganizations = () => {
  const { data, error, isLoading, isValidating, mutate } = useSWR(['orgs'], fetcher);

  const organizations = data ?? [];

  const refreshOrganizations = () => mutate();

  return {
    organizations,
    isLoading,
    isValidating,
    error,
    refreshOrganizations,
  };
};
